import { apiClient } from '../../utils';
import { handleError } from '../handleError';

export const createBlogService = async ({ siteId, name, idc }) => {
  try {
    const data = {
      site: siteId,
      nm: name,
      idc,
    };
    const rsp = await apiClient.post('/merchant/service/createBlogService', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
export const editBlogService = async ({ siteId, serviceId, name, idc }) => {
  try {
    const data = {
      site: siteId,
      service: serviceId,
      nm: name,
      idc,
    };
    const rsp = await apiClient.post('/merchant/service/updateBlogService', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};

export const deleteBlogService = async ({ siteId, serviceId }) => {
  try {
    const data = {
      site: siteId,
      service: serviceId,
    };
    const rsp = await apiClient.post('/merchant/service/deleteBlogService', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
